import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { useState as S, useCallback as A, useEffect as b } from "react";
import { UnifiedInputField as a, LabeledField as O, Dropdown as _, HierarchicalMenu as w, UnifiedSelectBox as B, SELECT_STATES as j } from "@placer-ui/components";
import "@tanstack/react-query";
import "qs";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import { useCreatePoiCategories as D } from "./index.es388.js";
import "./index.es4.js";
import "./index.es20.js";
import "./index.es12.js";
import { useAPIContext as L } from "./index.es46.js";
import "./index.es6.js";
import "./index.es99.js";
import "./index.es203.js";
import "./index.es204.js";
import "./index.es205.js";
import "./index.es206.js";
import "use-debounce";
import "@deck.gl/geo-layers/typed";
import "@deck.gl/core/typed";
import "@deck.gl/layers/typed";
import "react-map-gl";
import "mapbox-gl";
import "fabric";
import "./index.es170.js";
import "lodash/fp";
import "lodash/throttle";
import "lodash/debounce";
import "queue";
import "geobuckets";
import "./index.es207.js";
import "./index.es59.js";
import "./index.es74.js";
import "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "kdbush";
import "./index.es208.js";
import "./index.es84.js";
import "./index.es78.js";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es86.js";
import "lodash";
import "./index.es23.js";
import "./index.es18.js";
import "./index.es72.js";
import "./index.es209.js";
import "./index.es103.js";
import "@sentry/react";
import "./index.es43.js";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "react-dom";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es166.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es229.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "./index.es234.js";
import "./index.es131.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es235.js";
import "./index.es236.js";
import "./index.es137.js";
import { useCreatePoiValidation as M } from "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import { useCreatePoiFields as U, useCreatePOIActionsFields as V } from "./index.es487.js";
import m from "./index.es486.js";
const v = (s) => s.reduce((n, { children: o, label: p }) => {
  const c = {
    label: p,
    value: p,
    selected: j.unselected,
    children: o && v(o)
  };
  return [...n, c];
}, []), qe = () => {
  const { environment: s, token: n } = L(), o = D({ environment: s, token: n }), [p, c] = S(""), { updateValidation: u, errors: C, getFeedback: g } = M(), { name: y, address: I, city: x, subCategory: F, zipCode: P } = U(), { setField: r, resetFields: h } = V(), [l, f] = S([]), T = A(
    (t) => {
      const E = t.label;
      r("sub_category", E);
      const i = t.parents;
      if ((i == null ? void 0 : i.length) === 2) {
        const N = i[0], k = i[1], z = l[N].children[k];
        r("category", z.label);
      }
    },
    [l, r]
  );
  return b(() => () => {
    h();
  }, [h]), b(() => {
    o && f(v(o));
  }, [o]), /* @__PURE__ */ d("div", { "data-testid": "create-poi-edit-mode", className: m.wrapper, children: [
    /* @__PURE__ */ e("div", { className: m.section, children: /* @__PURE__ */ e(
      a,
      {
        label: "Name",
        placeholder: "POI name",
        onChange: (t) => {
          r("name", t);
        },
        value: y,
        asterix: !0,
        onBlur: () => {
          u("name");
        },
        required: !!C.name,
        isError: !!C.name,
        feedback: g("name"),
        testId: "create-poi-name"
      }
    ) }),
    /* @__PURE__ */ d("div", { className: m.section, children: [
      /* @__PURE__ */ e(
        a,
        {
          label: "Street",
          onChange: (t) => r("address", t),
          value: I,
          placeholder: "Street"
        }
      ),
      /* @__PURE__ */ d("div", { className: m.rowWrapper, children: [
        /* @__PURE__ */ e(
          a,
          {
            onChange: (t) => r("city", t),
            value: x,
            placeholder: "City"
          }
        ),
        /* @__PURE__ */ e(
          a,
          {
            onChange: (t) => {
              r("zip_code", t);
            },
            value: P || "",
            placeholder: "Zip Code",
            onBlur: () => u("zip_code"),
            feedback: g("zip_code"),
            testId: "create-poi-zip"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e("div", { className: m.section, children: /* @__PURE__ */ e(O, { asterix: !0, label: "Category", children: /* @__PURE__ */ e(
      _,
      {
        closeOnSelection: !0,
        trigger: /* @__PURE__ */ e(
          B,
          {
            placeholder: "Select a Category",
            value: F
          }
        ),
        onInlineSearch: c,
        scaleToAnchor: !0,
        disableAutoClosing: !1,
        children: /* @__PURE__ */ e(
          w,
          {
            searchTerm: p,
            items: l,
            setItems: f,
            singleSelectMode: !0,
            onItemSelect: (t) => {
              T(t);
            },
            expandOnSearch: !0
          }
        )
      }
    ) }) })
  ] });
};
export {
  qe as CreatePoiEdit
};
//# sourceMappingURL=index.es444.js.map
